import { render, staticRenderFns } from "./InventarioArvore.vue?vue&type=template&id=1dc76372&scoped=true"
import script from "./InventarioArvore.vue?vue&type=script&lang=js"
export * from "./InventarioArvore.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=1dc76372&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc76372",
  null
  
)

export default component.exports